import React, { useState } from "react";
import styled from "styled-components";
import cl from "classnames";
import { useTranslation } from "react-i18next";

//
import IconWrapper from "../icon-wrapper/IconWrapper";

export default function FaqCard({
  title = "Title",
  text = "Lorem ipsum dolor, sit ahi bgo",
}) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  function handleShow() {
    setShow((p) => !p);
  }

  return (
    <StyledFaqCard onClick={handleShow}>
      <div className="faq-card__top">
        <h1>{t(title)}</h1>
        <IconWrapper icon="arrow-down" w={32} h={32} iconW={16} iconH={16} />
      </div>
      <div
        className={cl("faq-card__freeSpace", {
          show,
        })}
      ></div>
      <div className="faq-card__bottom">
        <p
          className={cl("", {
            show,
          })}
        >
          {t(text)}
        </p>
      </div>
    </StyledFaqCard>
  );
}

const StyledFaqCard = styled.div`
  background-color: var(--white);
  padding: 24px;
  border: 1px solid var(--border);
  cursor: pointer;

  .faq-card {
    &__top {
      display: flex;
      align-items: center;
      gap: 40px;
      justify-content: space-between;

      h1 {
        color: var(--title);
      font-size: var(--fs-card-title);
        font-style: normal;
      font-weight: var(--fw-semibold);
      line-height: 1.35;
      }
    }

    &__freeSpace {
      height: 24px;
      max-height: 0;
      overflow: hidden;
      transition: all 0.75s cubic-bezier(0, 1, 0, 1);

      &.show {
        height: 24px;
        max-height: 9999px;
        transition: all 0.75s cubic-bezier(1, 0, 1, 0);
      }
    }

    &__bottom {
      p {
        color: var(--text);
      font-size: var(--fs-body-sm);
        font-style: normal;
      font-weight: var(--fw-regular);
      line-height: var(--lh-body);
      text-align: left;
        padding-right: 48px;
        padding-top: 0px;
        max-height: 0;
        overflow: hidden;
        transition: all 0.75s cubic-bezier(0, 1, 0, 1);

        &.show {
          height: auto;
          max-height: 9999px;
          transition: all 0.75s cubic-bezier(1, 0, 1, 0);
        }
      }
    }
  }
`;
